/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface LpInspectionControllerGetMultiplePdfDocuments$Params {

/**
 * PDF로 출력할 검사 ID 목록
 */
  ids: Array<string>;

/**
 * 진행 상황 모니터링용 세션 ID
 */
  sessionId?: string;
}

export function lpInspectionControllerGetMultiplePdfDocuments(http: HttpClient, rootUrl: string, params: LpInspectionControllerGetMultiplePdfDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, lpInspectionControllerGetMultiplePdfDocuments.PATH, 'get');
  if (params) {
    rb.query('ids', params.ids, {"style":"form","explode":true});
    rb.query('sessionId', params.sessionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

lpInspectionControllerGetMultiplePdfDocuments.PATH = '/api/lp-inspection/pdfs';
